<template>
    <ul class="options-list mb-6" style="border:solid 1px black;"    >
        <li v-for="(option, index) in options" :key="index" :class="{ 'selected-option': option.href == $route.path }"
            class="px-3 py-2"> 
            <router-link :to="option.href" class="has-text-black has-text-centered">{{ option.text }}</router-link>
        </li>
    </ul>
</template>


<script>
export default {
    data() {
        return {
            showOptions: false,
            options: [
            { text: 'Data sources', href: '/curation/data-sources' },
            { text: 'Deprecations', href: '/curation/deprecations' },
            { text: 'Synonyms', href: '/curation/synonyms' },
            ]
        };
    },    
}
</script>

<style lang="scss" scoped>

ul {
    display: flex
}

li {
    background-color: white;
    display: block;
    width: 100%;
    height: 100%;
}

li a {
    display: block;
    width: 100%;
    height: 100%;
}

li:last-child {
  border-bottom: none
}

.selected-option {
  background-color: #F2F2F2;
  font-weight: 700
}
</style>